export const environment = {
  production: true,  
  urlApi: 'https://odresenterpriseapiqa-gsged4hccqa9dehu.eastus2-01.azurewebsites.net',
  urlAPIGeneradorReporte: 'https://odresreportingserviceqa-gabecqe2fsfgb9dh.eastus2-01.azurewebsites.net/api',
  tokenCopomex: 'ae07fec1-522a-4ac9-b8af-cb7fdc6191dc',  
  urlServicioDireccion: 'https://appmovil.invextarjetas.com.mx/solicitud-digital/api/catalogs/getAddressByPostalCode/',
  urlsignalR: 'https://funcion-signalr-odres.azurewebsites.net/api/',
  urlApiReportes: 'http://108.181.194.119/oDresReportService/',
  invokeActionReportViewer : "DXXRDV",
  invokeActionReportDesigner : "/DXXRD/GetDesignerModel", 
};